/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_GroupInputs */

const en_create_group = /** @type {(inputs: Create_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Group`)
};

const fr_create_group = /** @type {(inputs: Create_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer le groupe`)
};

const de_create_group = /** @type {(inputs: Create_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe erstellen`)
};

const it_create_group = /** @type {(inputs: Create_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea gruppo`)
};

const ru_create_group = /** @type {(inputs: Create_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать группу`)
};

const es_create_group = /** @type {(inputs: Create_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear grupo`)
};

const zh_cn2_create_group = /** @type {(inputs: Create_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建组`)
};

const ja_create_group = /** @type {(inputs: Create_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループを作成`)
};

const hi_create_group = /** @type {(inputs: Create_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह बनाना`)
};

const pt_pt2_create_group = /** @type {(inputs: Create_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar grupo`)
};

/**
* | output |
* | --- |
* | "Create Group" |
*
* @param {Create_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const create_group = /** @type {((inputs?: Create_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_create_group(inputs)
	if (locale === "de") return de_create_group(inputs)
	if (locale === "it") return it_create_group(inputs)
	if (locale === "ru") return ru_create_group(inputs)
	if (locale === "es") return es_create_group(inputs)
	if (locale === "zh-CN") return zh_cn2_create_group(inputs)
	if (locale === "ja") return ja_create_group(inputs)
	if (locale === "hi") return hi_create_group(inputs)
	if (locale === "pt-PT") return pt_pt2_create_group(inputs)
	return en_create_group(inputs)
});